<script>
export default {
  name: "numberReveal",
  props: {
    phoneNumber: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isNumberRevealed: false
    }
  },
  computed: {
    displayedNumber() {
      if (!this.isNumberRevealed) {
        const parts = this.phoneNumber.split(' ')
        if (parts.length === 1) {
          return this.phoneNumber.slice(0, -3) + '...'
        }
        const countryCodeParts = parts.slice(0, -1)
        const lastPart = parts[parts.length - 1]
        const maskedLastPart = lastPart.slice(0, -3) + '...'
        return [...countryCodeParts, maskedLastPart].join(' ')
      }
      return this.phoneNumber
    },
  },
  methods: {
    handleNumberClick() {
      if (!this.isNumberRevealed) {
        this.isNumberRevealed = true
        return
      }
      this.initiateCall()
    },
    initiateCall() {
      const cleanedNumber = this.phoneNumber.replace(/\s/g, '')
      try {
        window.location.href = `tel:${cleanedNumber}`
      } catch (error) {
        this.$emit('call-number', this.phoneNumber)
      }
    },
    call() {},
  }
}
</script>

<template>
  <div class="phone-number-container">
    <el-button
        class="btn-secondary phone-number"
        icon="el-icon-phone"
        @click="handleNumberClick"
        v-track:102.click="call">
      <span class="btn-text" style="font-size: 20px">{{ displayedNumber }}</span>
    </el-button>
  </div>
</template>

<style scoped>
.phone-number {
  cursor: pointer;
  user-select: none;
  display: inline-flex;
  align-items: center;
  transition: color 0.3s ease;
  font-size: 20px;
}

.phone-number:hover {
  font-size: 21px;
}

.btn-secondary {
  font-family: DINosaur-a, sans-serif;
  border: 4px solid #cccccc;
  background-color: #ffffff;
  color: #003333;
  padding-top: 10px;
  padding-bottom: 10px;
  font-weight: 600;
}

.btn-text {
  font: 600 20px/26px DINosaur-a, sans-serif !important;
  color: #003333;
}
</style>



// WEBPACK FOOTER //
// src/components/common/numberReveal.vue